import React from 'react'
import './index.scss'
import ld from '@/assets/images/ld.png'
import xiuxi from '@/assets/images/xiuxi.png'
import jiedan from '@/assets/images/jiedan.png'
import CountUp from 'react-countup'
const DriverCard = (props) => {
    // 身份标识：判断是否为队长rewardAmount
    let {isLeader,driverAcceptOrder,driverCancelOrder,driverName,onlineTime,payableAmount,status} = props
    return (
        <div className="driver-card__box">
            <h2>
                <span>{driverName}</span>
                {
                    isLeader ? <img src={ld} alt="" /> : ''
                }
                {
                    status === 1 ? <img src={jiedan} alt="" /> : <img src={xiuxi} alt="" />
                }
            </h2>
            <div className="driver-info__box">
                <h3><span><CountUp start={0} end={driverAcceptOrder - driverCancelOrder} duration={2} />单</span><b>今日完单</b></h3>
                <h3><span><CountUp start={0} end={parseInt(onlineTime/60)} duration={2} />小时<CountUp start={0} end={onlineTime%60} duration={2} />分钟</span><b>在线时长</b></h3>
                <h3><span><CountUp start={0} end={payableAmount / 100} decimals={2} duration={2} />元</span><b>流水金额</b></h3>
            </div>
        </div>
    )
}
export default DriverCard
